import React from "react";
import { cardClasses, cardStatus } from "@/helpers/style.helpers";
import { ScanActionApiResponseNew } from "@/features/scanners/types";
import { beepOk, beepWarning } from "@/features/scanners/helpers";
import { Order, Bin } from "@/types";

interface ComponentProps {
  data: Partial<ScanActionApiResponseNew> | null;
  bin?: Partial<Bin> | null;
  order?: Partial<Order> | null;
}

const ContentComponent: React.FC<ComponentProps> = ({ data, bin }) => {
  if (!data) return <>Scan een bak barcode</>;

  const { code } = data;

  switch (code) {
    case "BIN_DATASTRING":
    case undefined:
      return <>Bak: {bin?.name}</>;

    case "BIN_NOT_FOUND":
      return <>Bak niet gevonden</>;

    case "INVALID_BARCODE_DATA":
      return <>Ongeldige barcode of bak in barcode</>;

    case "ORDER_NOT_FOUND":
      return <>Herstelling niet gevonden</>;

    default:
      if (bin) {
        return <>Bak: {bin?.name}</>;
      }
      return null;
  }
};

export const BinCard: React.FC<ComponentProps> = (props) => {
  let className = "";
  const { data, bin } = props;

  if (data) {
    switch (data.code) {
      case "BIN_DATASTRING":
        className = cardStatus.info;
        beepOk();
        break;
      case "ORDER_NOT_FOUND":
      case "BIN_NOT_FOUND":
      case "INVALID_BARCODE_DATA":
        className = cardStatus.error;
        beepWarning();
        break;
      case "ORDER_STATUS_TRANSITION_FAILED":
        className = cardStatus.error;
        beepWarning();
        break;
      default:
        if (bin) {
          className = cardStatus.info;
        } else {
          className = cardStatus.neutral;
        }
    }
  } else {
    className = cardStatus.neutral;
  }

  return (
    <div className={`${cardClasses} ${className}`}>
      <div className="flex flex-col items-center justify-center">
        {data?.qualityCheckProgress === 1 && <div className="m-4 font-semibold text-base">OK</div>}
        <ContentComponent {...props} />

        {typeof data?.qualityCheckProgress === "number" && (
          <div className="text-base">progress {data.qualityCheckProgress * 100}%</div>
        )}
        {data?.order?.friendlyId && <div className="m-4 text-base">Herstelling: {data.order.friendlyId}</div>}
      </div>
    </div>
  );
};
